import React from 'react';
import { COLORS } from '../constants';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log error to console (in production, send to error tracking service)
    this.setState({
      error,
      errorInfo
    });

    // In production, you could send to Firebase Analytics or Sentry:
    // logEvent(analytics, 'exception', {
    //   description: error.toString(),
    //   fatal: false
    // });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={styles.container}>
          <div style={styles.card}>
            <h1 style={styles.title}>😕 Oops! Something went wrong</h1>
            <p style={styles.message}>
              We're sorry for the inconvenience. Please try refreshing the page.
            </p>
            <button 
              onClick={() => window.location.reload()} 
              style={styles.button}
            >
              Refresh Page
            </button>
            {process.env.NODE_ENV === 'development' && (
              <details style={styles.details}>
                <summary>Error Details (Dev Only)</summary>
                <pre style={styles.errorText}>
                  {this.state.error && this.state.error.toString()}
                  {this.state.errorInfo && this.state.errorInfo.componentStack}
                </pre>
              </details>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f5f5f5',
    padding: '20px'
  },
  card: {
    backgroundColor: 'white',
    padding: '40px',
    borderRadius: '12px',
    boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
    maxWidth: '600px',
    textAlign: 'center'
  },
  title: {
    color: COLORS.primary,
    fontSize: '24px',
    marginBottom: '16px'
  },
  message: {
    color: '#666',
    fontSize: '16px',
    marginBottom: '24px',
    lineHeight: '1.6'
  },
  button: {
    backgroundColor: COLORS.primary,
    color: 'white',
    border: 'none',
    padding: '12px 32px',
    borderRadius: '8px',
    fontSize: '16px',
    cursor: 'pointer',
    fontWeight: '600'
  },
  details: {
    marginTop: '24px',
    textAlign: 'left',
    backgroundColor: '#f9f9f9',
    padding: '16px',
    borderRadius: '8px',
    fontSize: '12px'
  },
  errorText: {
    whiteSpace: 'pre-wrap',
    color: '#e74c3c',
    fontSize: '11px'
  }
};

export default ErrorBoundary;
